import { fetchData } from '../../../http/Http';

export const fetchImageById = async (imageId: string): Promise<any> => {
    const response = await fetchData(`/images/${imageId}`, 'GET');
    return response.data;
};
